const {
	toggleClass,
	onClickOrEnter,
	$each,
	$find,
	hasPermRole,
	hasPermKey,
	getItemsWithSubmenus,
	setupHoverMenuOn,
	removeEl,
	compileTemplate,
	closeSubmenusExcept,
	runAjax,
} = require("./ElevHelpers");
const {loadCartFromStorage, updateTopBarCart} = require("./CartUtil");
const {
	getItemCountWithBundlesAndSets,
} = require("../../../../shared/StoreUtil");
const {isPlaygroundActivityPage} = require("./PlaygroundUtil");
const {getUserTopBarName} = require("../../../../shared/UserDataUtil");
const {getFeatureFlag} = require("../../../core/util/FeatureFlags");
const Constants = require("../../../../shared/Constants");
const ElevShared = require("../../../../shared/ElevShared");
const Cookie = require("../../../core/util/Cookie");

// Default info bar, also used for 11ty pages (TopBar.jsx getInitialState infoBarType)
const {DEFAULT_INFO_BAR_TYPE} = require("../../../../shared/Infobars");
const {
	isUnregisteredStudent,
} = require("../../../parent/util/PrimaryRegistrationUtil");
const {getStudentRegistrationPage} = require("../../../core/vault/OpsPage");
const OVERRIDE_INFO_BAR_TYPE = undefined; // set to undefined for no override

//
// JS for top bar
//

// Returns true if the user can add additional student accounts. This just
// checks if the user.students array has hit the limit for number of subs,
// both inactive and active bounds. Doesn't check if the user is a parent; we
// assume this function will not be called in that case.
function canAddStudent(user) {
	if (!user) {
		return false;
	}
	const students = user.students || [];
	if (students.length >= Constants.MAX_INACTIVE_SUBSCRIPTIONS_FOR_PARENT) {
		return false;
	}
	const activeStudents = user.students.filter(s => s.isActive);
	if (activeStudents.length >= Constants.MAX_SUBSCRIPTIONS_FOR_PARENT) {
		return false;
	}
	return true;
}

function setupTopBarShrinking(topBarOuter) {
	if (!topBarOuter.classList.contains("--can-shrink")) {
		return;
	}

	const header = document.querySelector(".ba11-top");
	const topSection = document.querySelector(".ba11-top-section");
	if (header && topSection) {
		/**
		 * The (sometimes shrinkable) top bar is rendered outside of the normal
		 * document flow (at full width), so we need to put top padding above
		 * our usual page content to provide the necessary space. This is where
		 * we do that.
		 */
		const alignTopSection = () => {
			const rect = header.getBoundingClientRect();
			const style = getComputedStyle(header);
			const paddingHeight =
				style.position === "fixed"
					? rect.height + parseFloat(style.marginTop)
					: 0; // if part of normal document flow, don't give extra space
			topSection.style.paddingTop = `${paddingHeight}px`;
		};
		alignTopSection();
		const resizeObserver = new ResizeObserver(alignTopSection);
		resizeObserver.observe(header);
	}

	let prevScrollY = window.scrollY;
	document.addEventListener("scroll", function(evt) {
		const scrollY = window.scrollY;
		// TODO: account for DisableScroll check in old code?
		if (scrollY > prevScrollY && scrollY > 1) {
			// Shrink
			toggleClass(topBarOuter, "--shrink", true);
			const toDisable = document.querySelectorAll(".no-tab-on-shrink");
			toDisable.forEach(el => el.setAttribute("tabindex", -1));
			const toEnable = document.querySelectorAll(".tab-on-shrink");
			toEnable.forEach(el => el.setAttribute("tabindex", 0));
			const toBlur = document.querySelectorAll(".ba11-top-shared-link");
			toBlur.forEach(el => el.blur());
			closeSubmenusExcept();
		} else if (scrollY < prevScrollY && scrollY < 100) {
			// Unshrink
			toggleClass(topBarOuter, "--shrink", false);
			const toDisable = document.querySelectorAll(".tab-on-shrink");
			toDisable.forEach(el => el.setAttribute("tabindex", -1));
			const toEnable = document.querySelectorAll(".no-tab-on-shrink");
			toEnable.forEach(el => el.setAttribute("tabindex", 0));
		}
		prevScrollY = scrollY;
	});
}

function setupTopBarHamburger() {
	const hamburgerButton = document.querySelector(".ba11-top-nav-ham-link");
	const hamburgerMenu = document.querySelector(".ba11-ham-nav-container");
	if (!hamburgerMenu || !hamburgerButton) {
		return;
	}

	document.addEventListener("click", function(evt) {
		const topSiteNode = document.querySelector(".ba11-top-shared-inner");
		const topAccountNode = document.querySelector(".ba11-top-account-menu");
		const topMenuNode = document.querySelector(".ba11-top-menu-container");
		const clickLocation = evt.target;
		if (
			(!topSiteNode || !topSiteNode.contains(clickLocation)) &&
			(!topMenuNode || !topMenuNode.contains(clickLocation)) &&
			(!topAccountNode || !topAccountNode.contains(clickLocation))
		) {
			closeSubmenusExcept();
		}
	});

	let hamburgerIsOpen = false;
	hamburgerButton.addEventListener("click", function(evt) {
		evt.preventDefault();
		hamburgerIsOpen = !hamburgerIsOpen;
		toggleClass(hamburgerMenu, "ba11--open", hamburgerIsOpen);
	});

	$each(hamburgerMenu, ".ba11-ham-nav-section", function(el) {
		const titleEl = el.querySelector(".ba11-ham-nav-section-title");
		const linkEl = el.querySelector(".ba11-ham-nav-section-title-link");
		const submenuEl = el.querySelector(".ba11-ham-nav-submenu");
		if (titleEl && linkEl && submenuEl) {
			let sectionIsOpen = false;
			titleEl.addEventListener("click", function(evt) {
				evt.preventDefault();
				sectionIsOpen = !sectionIsOpen;
				toggleClass(submenuEl, "ba11--open", sectionIsOpen);
				linkEl.setAttribute("aria-expanded", sectionIsOpen);
			});
		}
	});
}

function setupTopBarCart() {
	const cart = loadCartFromStorage();
	updateTopBarCart(getItemCountWithBundlesAndSets(cart.items));
}

function setupTopBarColor() {
	const colorSection = document.querySelector("#headerContainer");

	if (process.env.NODE_ENV !== "production") {
		const navBarDevColors = window.localStorage.getItem(
			"flag_navBarColorChanges"
		);
		if (navBarDevColors !== "false") {
			colorSection.classList.add("--dev");
		}
	}
}

function setupTopBarInfoBar(user) {
	const infoBarEls = $find(document, ".ba11-top-info-bar");
	const infoBarTypes = infoBarEls.map(el => el.getAttribute("data-infotype"));
	const brandBorderEl = document.querySelector(".ba11-top-brand-border");
	const topBarEl = document.querySelector(".ba11-top-outer");
	const showClass = "ba11--show";
	const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
	const cookieHideValue = "hide";

	function updateInfoBar(infoBarType) {
		const today = new Date();
		const barIndices = infoBarTypes.reduce((indices, type, index) => {
			if (type === infoBarType) {
				indices.push(index);
			}
			return indices;
		}, []);

		/* Apparently the header has certain style needs if there are info
		bars. Toggle them on if there are info bars. */
		const hasInfoBars = barIndices.length > 0;
		if (brandBorderEl) {
			brandBorderEl.style.display = hasInfoBars ? "none" : "";
		}
		if (topBarEl) {
			topBarEl.classList.toggle("ba11--has-info", hasInfoBars);
		}

		const activeConferenceBanner = getActiveConferenceBanner();
		if (activeConferenceBanner) {
			const dataCookie = activeConferenceBanner.getAttribute("data-cookie");

			activeConferenceBanner.classList.add(showClass);

			activeConferenceBanner.lastElementChild.addEventListener("click", () => {
				activeConferenceBanner.classList.remove(showClass);

				Cookie.set(dataCookie, cookieHideValue, thirtyDaysInMs);
			});

			return;
		}

		const nonConferenceInfoBarEls = infoBarEls.filter(
			bar => !bar.getAttribute("data-educators")
		);
		nonConferenceInfoBarEls.forEach((el, i) => {
			const dataCookie = el.getAttribute("data-cookie");
			const neverHide = el.getAttribute("data-never-hide") === "true";
			let start = el.getAttribute("data-start");
			if (start) {
				start = new Date(start);
			}
			let end = el.getAttribute("data-end");
			if (end) {
				end = new Date(end);
			}

			const isSameType = barIndices.includes(i);
			const hasntCookie =
				neverHide || Cookie.get(dataCookie) !== cookieHideValue;
			const afterStart = !start || start < today;
			const beforeEnd = !end || today < end;
			el.classList.toggle(
				showClass,
				isSameType && hasntCookie && afterStart && beforeEnd
			);

			el.lastElementChild.addEventListener("click", () => {
				el.classList.remove(showClass);

				if (!neverHide) {
					Cookie.set(dataCookie, cookieHideValue, thirtyDaysInMs);
				}
			});
		});

		function getActiveConferenceBanner() {
			const isEducatorsPage = /^\/educators\/?$/.test(location.pathname);
			if (!isEducatorsPage) return;

			const educatorInfobarIdx = infoBarEls.findIndex(
				e => e.getAttribute("data-educators") === "true"
			);
			if (educatorInfobarIdx === -1) return;
			const educatorInfobar = infoBarEls.splice(educatorInfobarIdx, 1)[0];

			const hiddenCookie = Cookie.get(
				educatorInfobar.getAttribute("data-cookie")
			);
			if (hiddenCookie === cookieHideValue) return;

			const start = educatorInfobar.getAttribute("data-start");
			if (start && today < new Date(start)) {
				return;
			}

			const end = educatorInfobar.getAttribute("data-end");
			if (end && new Date(end) < today) {
				return;
			}

			return educatorInfobar;
		}
	}

	function getCurrInfoBarType() {
		const type = OVERRIDE_INFO_BAR_TYPE || window.officeInfoBarType;
		// Don't show info bar on playground activity page
		// unless it's site-maintenance or primary-registration-reminder
		if (
			type !== "site-maintenance" &&
			type !== "primary-registration-reminder" &&
			isPlaygroundActivityPage()
		) {
			return null;
		}
		if (type === undefined) {
			if (user) {
				// Show IPL migration infobar for all staff at IPL-managed schools
				if (
					user.staffForPurchaseID &&
					user.staffRoles &&
					user.staffRoles.isAopsManaged === false
				) {
					return "ipl-migration";
				}
				// don't show custom infotype for teachers
				const isTeacher = hasPermRole(user, "teacher");
				if (isTeacher && DEFAULT_INFO_BAR_TYPE === "custom") {
					return null;
				}

				// Check if we should show the primary registration reminder for unregistered students
				const isParent = hasPermRole(user, "parent");
				if (isParent && user.students && user.students.length > 0) {
					const hasUnregisteredStudents = user.students.some(
						isUnregisteredStudent
					);
					if (hasUnregisteredStudents) {
						return "primary-registration-reminder";
					}
				}
			}
			return DEFAULT_INFO_BAR_TYPE;
		}
		return type;
	}

	// Diagnostic logging for IPL migration infobar (PR #7615): surface the
	// inputs that decide whether "ipl-migration" is selected. Logged once on
	// setup (getCurrInfoBarType also runs on a 1s interval) to avoid spam.
	const iplStaffRoles = (user && user.staffRoles) || {};
	// eslint-disable-next-line no-console
	console.log("[ipl-infobar] elev infobar inputs:", {
		hasUser: !!user,
		staffForPurchaseID: user && user.staffForPurchaseID,
		hasStaffRoles: !!(user && user.staffRoles),
		isAopsManaged: iplStaffRoles.isAopsManaged,
		isAopsManagedType: typeof iplStaffRoles.isAopsManaged,
		overrideInfoBarType: OVERRIDE_INFO_BAR_TYPE,
		windowOfficeInfoBarType: window.officeInfoBarType,
	});
	let currBar = getCurrInfoBarType();
	updateInfoBar(currBar);

	setInterval(() => {
		const newBar = getCurrInfoBarType();
		if (newBar !== undefined && newBar !== currBar) {
			currBar = newBar;
			updateInfoBar(newBar);
		}
	}, 1000);
}

const getAvatarHTML = function(avatarURL, bgColor) {
	const hasBGColor = bgColor && /^#[a-zA-Z0-9]+$/.test(bgColor);
	const bgStyle = hasBGColor ? `style="background-color: ${bgColor}"` : "";
	return (
		`<div class="ba11-avatar-bg" ${bgStyle}></div>` +
		`<img class="ba11-avatar-img" alt="Avatar" src="${avatarURL}">` +
		`<div class="ba11-avatar-ring"></div>`
	);
};

const getAvatarHTMLFromData = function(avatarData) {
	const avatarURL = ElevShared.getAvatarURL(avatarData);
	if (!avatarData || !avatarURL) return "";
	return getAvatarHTML(avatarURL, avatarData.color);
};

/**
 * In the various dropdown menus of the top bar, some items should be
 * conditionally rendered based on the logged in user. These are included in
 * topnav.yaml as a cond value. This is part of the implementation of that
 * system.
 *
 * This function returns an array of conds, based on the logged in user, where
 * conds are strings. The cond values on topnav.yaml, which get into the HTML
 * via a data-cond key, are treated as a comma separated list, usually a single
 * element. If there is no cond, we always render the item. Otherwise, we
 * render the item if there is any overlap between the list in data-cond and
 * the list returned by this function. satisfiesTopBarCond implements these
 * checks.
 *
 * @param {object|null} user The user as returned from /api/user/current. Null
 *   if no user is logged in.
 * @returns {string[]} The array of conds which should be rendered.
 */
function getUserTopBarConds(user) {
	if (!user || !user.roles) {
		return ["guest"];
	}

	const hasKey = key => hasPermKey(user, key);
	const hasRole = role => hasPermRole(user, role);

	if (hasRole("student") || hasRole("student deactivated")) {
		return ["student"];
	}

	const conds = [];

	if (hasKey("admin view")) {
		conds.push("aops");
	}

	const staffRoles = user.staffRoles || {};
	if (staffRoles.adminPurchase) {
		conds.push("purchase");
		conds.push("purchaseadmin");
		if (!staffRoles.isSingleSchool) {
			conds.push("multischoolpurchaseadmin");
		}
		if (user.staffForPurchaseID !== Constants.ACADEMY_PURCHASE_ID) {
			conds.push("rostering");
		}
	} else if (
		staffRoles.adminSchoolIDs &&
		staffRoles.adminSchoolIDs.length > 0
	) {
		conds.push("purchase");
		conds.push("schooladmin");
		if (!staffRoles.isSingleSchool) {
			// Intentional contraction of multischoolschooladmin.
			conds.push("multischooladmin");
		}
	} else if (user.staffForPurchaseID) {
		conds.push("purchase");
		conds.push("teacher");
	} else if (hasRole("parent")) {
		// Only set parent if not in purchase to avoid duplicate menus.
		conds.push("parent");
	}

	return conds;
}

// Returns true if a top bar item should be included. First parameter is the
// return of getUserTopBarConds; second is the data-cond attribute value. See
// that function for details.
function satisfiesTopBarCond(userConds, condAttr) {
	if (!condAttr) return true;
	return condAttr.split(",").some(cond => userConds.indexOf(cond) > -1);
}

function setupItemsWithSubmenu() {
	getItemsWithSubmenus().forEach(el => setupItemWithSubmenu(el));
}

function setupItemWithSubmenu(el) {
	setupHoverMenuOn(el);

	// Temporarily disable keyboard navigation so top level items
	// can be clickable

	// // Make navigable via keyboard by using top menu item as a toggle
	// function leaveAsLink() {
	// 	const leaveAsLinkAtNarrowWidth =
	// 		hasClass(el, "ba11-top-shared-unsel") ||
	// 		hasClass(el, "ba11-top-shared-sel");
	// 	const windowWidth = window && window.innerWidth;
	// 	return leaveAsLinkAtNarrowWidth && windowWidth && windowWidth <= 700;
	// }

	// const toggleEl = el.querySelector("a");
	// setupToggleOn(el, toggleEl, {leaveAsLinkFunc: leaveAsLink});
}

function setupTopBarSignin(user) {
	const signinButton = document.querySelector(".ba11-top-account-login");
	if (signinButton && user) {
		removeEl(signinButton);
	} else if (signinButton) {
		onClickOrEnter(signinButton, function(evt) {
			window.location = "/signin";
		});
		signinButton.classList.remove("ba11--gray");
	}

	const accountMenu = document.querySelector(".ba11-top-account-menu");
	if (accountMenu && !user) {
		removeEl(accountMenu);
	} else if (accountMenu) {
		const nameEl = accountMenu.querySelector(".ba11-top-account-name");
		if (nameEl) {
			const shownName = getUserTopBarName(
				user,
				getFeatureFlag("ENABLE_UNIFIED_ACCOUNTS")
			);
			nameEl.innerText = shownName;
		}

		const avatarEl = accountMenu.querySelector(".ba11-top-account-avatar");
		const avatarHTML = getAvatarHTMLFromData(user.avatarData);
		if (avatarEl && avatarHTML) {
			avatarEl.innerHTML = avatarHTML;
		} else if (avatarEl) {
			avatarEl.innerHTML = `<img class="ba11-avatar-img" alt="Logo" src="/assets/images/icons/default-avatars/parent.svg">`;
		}

		const userConds = getUserTopBarConds(user);
		$each(accountMenu, ".ba11-top-account-item", itemEl => {
			const condAttr = itemEl.getAttribute("data-cond");
			if (!satisfiesTopBarCond(userConds, condAttr)) {
				removeEl(itemEl);
			}
		});

		accountMenu.classList.remove("ba11--hidden");
	}
}

function setupTopBarShownSubmenus(user) {
	const userConds = getUserTopBarConds(user);

	const processParentMenu = itemEl => {
		const condAttr = itemEl.getAttribute("data-cond");
		if (satisfiesTopBarCond(userConds, condAttr)) {
			$each(
				itemEl,
				".ba11-top-menu-submenu-link, .ba11-ham-nav-submenu-link",
				processSubMenu
			);
			itemEl.classList.remove("ba11--hidden");
		} else {
			removeEl(itemEl);
		}
	};

	const processSubMenu = itemEl => {
		const condAttr = itemEl.getAttribute("data-cond");
		if (!satisfiesTopBarCond(userConds, condAttr)) {
			removeEl(itemEl);
		}
	};

	$each(document, ".ba11-top-menu, .ba11-ham-nav-section", processParentMenu);
}

function setupTopBarOfferingsMenu(user) {
	const userConds = getUserTopBarConds(user);
	const isParent = userConds.includes("parent");
	if (!isParent) {
		const parentOnlySection = document.querySelector(
			".ba11-top-menu-offerings .ba11-parent-only"
		);
		if (parentOnlySection) {
			parentOnlySection.classList.add("ba11--hidden");
		}
	}
}

// Given a student in a loaded parent and a base element, return a clone of the
// base element with student info filled in. The base element should be the
// data-parentstudent element in the top bar template.
function createTopBarSubmenuElForStudent(baseEl, student, forHamburgerMenu) {
	const newEl = baseEl.cloneNode();
	newEl.removeAttribute("data-parentstudents");

	const linkEl = document.createElement("a");
	if (forHamburgerMenu) {
		linkEl.classList.add("ba11-ham-nav-submenu-link");
	} else {
		linkEl.classList.add(
			"ba11-top-menu-submenu-link",
			"ba11-top-menu-student-link"
		);
	}
	const registrationLink = getStudentRegistrationPage(student.id);
	const linkTo = student.hasRegistered
		? `/parent/students/${student.id}/progress`
		: registrationLink;
	linkEl.setAttribute("href", linkTo);
	newEl.appendChild(linkEl);

	const avatarEl = document.createElement("div");
	avatarEl.classList.add("ba11-top-menu-avatar");
	const avatarHTML = getAvatarHTMLFromData(student.avatarData);
	avatarEl.innerHTML = avatarHTML;
	linkEl.appendChild(avatarEl);

	const nameEl = document.createTextNode(student.displayName);
	linkEl.appendChild(nameEl);

	return newEl;
}

function setupTopBarParentStudentList(user) {
	const generateSubmenuItems = (submenuEl, forHamburgerMenu) => {
		const parentStudentsEl = submenuEl.querySelector("[data-parentstudents]");
		if (parentStudentsEl) {
			const containerEl = parentStudentsEl.parentNode;
			if (user && user.students && user.students.length) {
				user.students.forEach(student => {
					const studentEl = createTopBarSubmenuElForStudent(
						parentStudentsEl,
						student,
						forHamburgerMenu
					);
					containerEl.insertBefore(studentEl, parentStudentsEl);
				});
			}
			removeEl(parentStudentsEl);
		}

		$each(submenuEl, "[data-avatar]", avatarEl => {
			const avatar = avatarEl.getAttribute("data-avatar");
			if (avatar === "team") {
				avatarEl.innerHTML = getAvatarHTML(
					"/assets/images/characters/avatars/avatar-team.svg"
				);
			}
		});
	};

	$each(document, ".ba11-top-menu-submenu", el =>
		generateSubmenuItems(el, false)
	);
	$each(document, ".ba11-ham-nav-submenu", el =>
		generateSubmenuItems(el, true)
	);
}

function setupTopBarAddStudentVis(user) {
	const addOK = canAddStudent(user);
	if (addOK) return;
	$each(document, "[data-addstudent]", addStudentEl => {
		removeEl(addStudentEl);
	});
}

function signOutAndGoToStudentLogin(student) {
	// Academy students don't have a username, just go to the login page with no pre-fill.
	if (student.username) {
		const signinLink = encodeURIComponent(
			`/school/signin-prefill/${student.username}`
		);
		window.location = "/signout?requestedURL=" + signinLink;
	} else {
		window.location = "/signout?requestedURL=/school/signin";
	}
}

function signInAsStudent(student) {
	runAjax(
		{
			endpoint: "/api/session/imitateStudent",
			payload: {
				studentID: student.id,
			},
		},
		(err, res) => {
			if (err || !res || !res.success) {
				// If the sign in fails, sign out and go to student login page
				signOutAndGoToStudentLogin(student);
			} else {
				// If the sign in succeeds, go to school page
				window.location = "/school";
			}
		}
	);
}

// Given a student for a logged in parent, insert a row in the play dropdown
// if they are active. If they haven't registered, show name in grey and fire
// modal to tell user to go register them.
function createTopBarSubmenuElForPlayStudent(student) {
	const newEl = document.createElement("a");
	const {id, displayName, avatarData, username, hasRegistered} = student;
	newEl.setAttribute(
		"class",
		"ba11-top-menu-submenu-link ba11-top-menu-play-link"
	);
	if (!hasRegistered)
		toggleClass(newEl, "ba11-top-menu-play-link-disabled", true);

	if (student.hasRegistered) {
		// Log out and go to student login page with username prefilled
		newEl.addEventListener("click", evt => {
			evt.preventDefault();
			signInAsStudent(student);
		});
	} else {
		// Direct link to primary registration
		newEl.addEventListener("click", evt => {
			evt.preventDefault();
			window.location.href = `/parent/students/setup/${id}`;
		});
	}
	newEl.setAttribute("tabindex", 0);
	const avatarHTML = getAvatarHTMLFromData(avatarData);
	const playDropdownStudentTemplate = compileTemplate(
		"#playDropdownStudentTemplate"
	);
	const hbVars = {
		avatarHTML,
		displayName,
		username,
		showSetupText: !hasRegistered,
	};
	const contents = playDropdownStudentTemplate(hbVars);
	newEl.innerHTML = contents;

	return newEl;
}

/**
 * When ENABLE_DAILY_PUZZLES is on, align elev top nav + footer with React office
 * CopyTable (Daily Puzzles → /puzzles/daily). YAML stays All Ten for static build.
 */
function setupDailyPuzzlesNavLabels() {
	if (!getFeatureFlag("ENABLE_DAILY_PUZZLES")) {
		return;
	}
	$each(
		document,
		'.ba11-top-outer a[href="/all-ten"], .ba11-bottom-bar-main a[href="/all-ten"]',
		el => {
			el.setAttribute("href", "/puzzles/daily");
			el.textContent = "Daily Puzzles";
		}
	);
}

function setupPlayDropdownStudentList(user) {
	$each(document, ".ba11-top-menu-container", topMenuEl => {
		if (
			user &&
			user.students &&
			user.students.length &&
			user.students.some(s => s.isActive || s.inActiveClasses)
		) {
			const playEl = topMenuEl.querySelector(".ba11-top-menu-play");
			toggleClass(playEl, "has-submenu", true);
			setupHoverMenuOn(playEl);
			const playStudentsSubmenu = playEl.querySelector(
				".ba11-top-menu-submenu"
			);
			user.students.forEach(student => {
				if (student.isActive || student.inActiveClasses) {
					const studentEl = createTopBarSubmenuElForPlayStudent(student);
					playStudentsSubmenu.appendChild(studentEl);
				}
			});
		}
	});
}

function setupTopBar(user) {
	setupDailyPuzzlesNavLabels();
	const topBarOuter = document.querySelector(".ba11-top-outer");
	if (!topBarOuter) {
		return;
	}
	setupItemsWithSubmenu();
	setupTopBarShrinking(topBarOuter);
	setupTopBarHamburger();
	setupTopBarCart(topBarOuter);
	setupTopBarColor();
	setupTopBarInfoBar(user);

	// Turn off/on focus-styling if we think mouse is being/not being used.
	// by seeing when mouse event is used.
	// https://stackoverflow.com/questions/31402576/enable-focus-only-on-keyboard-use-or-tab-press/51093815#51093815

	document.body.addEventListener("keydown", function(event) {
		if (event.keyCode === 9) {
			document.body.classList.add("focus-styling-on");
		}
	});

	document.body.addEventListener("mousedown", function() {
		document.body.classList.remove("focus-styling-on");
	});
}

function setupTopBarPostAuth(user) {
	const topBarOuter = document.querySelector(".ba11-top-outer");
	if (topBarOuter && user) {
		toggleClass(topBarOuter, "--signed-in", true);
	}
	setupTopBarSignin(user);
	setupTopBarParentStudentList(user);
	setupTopBarOfferingsMenu(user);
	setupTopBarShownSubmenus(user);
	setupPlayDropdownStudentList(user);
	setupTopBarAddStudentVis(user);
}

module.exports = {
	setupTopBar,
	setupTopBarPostAuth,
};
